import { supabase } from "@/lib/supabase";
import { Project } from "@/types/types";

export const projectService = {
  async getProjects(): Promise<Project[]> {
    const { data, error } = await supabase.from("works").select("*");

    if (error) {
      throw new Error(error.message);
    }

    return data.map((item) => ({
      id: item.id.toString(),
      title: item.title,
      description: item.description,
      tags: item.tags,
      image: item.image,
      githuburl: item.githuburl,
      liveurl: item.liveurl,
      completion: item.completion,
      status: item.status,
      livefigma: item.livefigma,
    }));
  },

  subscribeToChanges(callback: () => void) {
    const subscription = supabase
      .channel("works-changes")
      .on(
        "postgres_changes",
        {
          event: "*",
          schema: "public",
          table: "works",
        },
        callback
      )
      .subscribe();

    return subscription;
  },
};
